import React from "react";
const Name = ({ setFamilyname, setFirstname, familyname, firstname }) => {
  return (
    <React.Fragment>
      <h6 className="text-fw-bold text-center mb-3_5 line-height-2">
        お名前を教えてください
      </h6>
      <p className="p-0 text-fz-small">
        *お名前は後で変更できる回数が限られています。きちんと入力されていないと参加できないサークルもあるので、正確にご入力ください。
      </p>
      <div className="" style={{ paddingTop: "30px", paddingBottom: "180px" }}>
        <ul className="nav flex-column">
          <li className="nav-item p-3 border-bottom">
            <div className="row">
              <div className="col-4" style={{ height: "25px", opacity: "0.7" }}>
                姓
              </div>
              <div className="col-8">
                <input
                  type="text"
                  className="form-control"
                  style={{ border: "none", backgroundColor: "#f5f5f5" }}
                  onChange={(e) => setFamilyname(e.target.value)}
                  value={familyname}
                />
              </div>
            </div>
          </li>
          <li className="nav-item p-3 border-bottom">
            <div className="row">
              <div className="col-4" style={{ height: "25px", opacity: "0.7" }}>
                名
              </div>
              <div className="col-8">
                <input
                  type="text"
                  className="form-control"
                  style={{ border: "none", backgroundColor: "#f5f5f5" }}
                  onChange={(e) => setFirstname(e.target.value)}
                  value={firstname}
                />
              </div>
            </div>
          </li>
        </ul>
      </div>
    </React.Fragment>
  );
};
export default Name;